'use strict';

define(['app', '$window', 'accessibilityFocusHelper'], function (app, $window, accessibilityFocusHelper) {
  var accordionWidget = function accordionWidget() {
    var comp = {};
    var _config = {
      attribs: {
        ariaHidden: 'aria-hidden',
        ariaExpanded: 'aria-expanded'
      },
      selectors: {
        title: '.accordionWidget_sectionTitle',
        content: '.accordionWidget_sectionContent',
        focusableElements: 'button, a'
      },
      tracking: {
        enabled: false,
        channel: 'accordionWidget',
        extra: undefined
      },
      animationTime: 150,
      offset: 0,
      isOpen: false
    };

    var _init = function _init(el) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      comp.config = Object.assign({}, comp.config, config);

      if (!comp.config.selectors.focusableElements) {
        comp.config.selectors.focusableElements = _config.selectors.focusableElements;
      }

      comp.element = el;
      comp.title = el.querySelector(comp.config.selectors.title);
      comp.content = el.querySelector(comp.config.selectors.content);
      comp.title.addEventListener('click', comp.toggle);
      if (comp.config.isOpen) {
        comp.open();
      } else {
        comp.close();
      }
      return comp;
    };

    var _toggle = function _toggle() {
      // reset the height so css can interpolate
      var height = comp.title.offsetHeight + comp.content.offsetHeight;
      comp.element.style['max-height'] = height + 'px';
      if (comp.timeout) {
        $window.clearTimeout(comp.timeout);
        comp.timeout = null;
      }
      // set the max-height accordingly, must be deffered
      if (!comp.opened) {
        comp.timeout = $window.setTimeout(comp.open, comp.config.animationTime);
        // if the widget is inside a collection, trigger the collection
        if (comp.element.collection) {
          comp.element.collection.trigger(comp);
        }
        if (comp.config.tracking.enabled) {
          app.publish('tracking/record', comp.config.tracking.channel, 'open', 'accordion', comp.config.tracking.extra);
        }
      } else {
        comp.timeout = $window.setTimeout(comp.close, 0);
        if (comp.config.tracking.enabled) {
          app.publish('tracking/record', comp.config.tracking.channel, 'close', 'accordion', comp.config.tracking.extra);
        }
      }
      comp.opened = !comp.opened;
    };

    var _open = function _open() {
      comp.element.style['max-height'] = 'none';
      comp.title.setAttribute(comp.config.attribs.ariaExpanded, 'true');
      comp.content.removeAttribute(comp.config.attribs.ariaHidden);
      accessibilityFocusHelper.enableElements(comp.content.querySelectorAll(comp.config.selectors.focusableElements));
      comp.element.classList.add('accordionWidget_expanded');
      comp.timeout = null;
      comp.opened = true;
    };

    var _close = function _close() {
      comp.element.style['max-height'] = comp.title.offsetHeight + comp.config.offset + 'px';
      comp.title.setAttribute(comp.config.attribs.ariaExpanded, 'false');
      comp.content.setAttribute(comp.config.attribs.ariaHidden, 'true');
      accessibilityFocusHelper.disableElements(comp.content.querySelectorAll(comp.config.selectors.focusableElements));

      if (comp.element.classList.contains('accordionWidget_expanded')) {
        comp.element.classList.remove('accordionWidget_expanded');
      }

      comp.timeout = null;
      comp.opened = false;
    };

    comp.init = _init;
    comp.config = Object.assign({}, _config);
    comp.toggle = _toggle;
    comp.open = _open;
    comp.close = _close;
    return comp;
  };
  return accordionWidget;
});
//# sourceMappingURL=accordionWidget.js.map
